import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const SAFE_ZONE_NEAREST_KEY = ["safe-zone", "nearest"];

export const safeZoneApi = {
  nearest: () => api.get("/safe-zones/nearest").then((r) => r.data),
};

export function useNearestSafeZone(enabled = true) {
  return useQuery({
    queryKey: SAFE_ZONE_NEAREST_KEY,
    queryFn: safeZoneApi.nearest,
    enabled,
    staleTime: 5 * 60 * 1000, // 5 min
    refetchOnWindowFocus: false,
  });
}
